import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconNotes } from "../../../../images/iconNotes.svg";
import Item from "../Item";

export default function ClassificacaoELA({ data, small }) {
  return (
    <Accordion defaultExpanded={false} className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="ClassificacaoELA-content"
        id="ClassificacaoELA-header"
        className={`AccordionSummaryContainer ${small ? "small" : ""}`}
      >
        <Stack direction="row" alignItems="center" gap="8px " height="30px">
          <IconNotes style={{ width: "24px" }} />
          <Typography className={`Accordion_title ${small ? "small" : ""}`}>
            Classificação da ELA
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack>
          {(data.diagnosticoEhELA === "Sim" ||
            data.diagnosticoEhELA === "Em investigação") && (
            <Stack>
              <Stack className="template-grid column-4">
                <Item
                  label="O diagnóstico é ELA?"
                  text={data.diagnosticoEhELA}
                />
                <Item
                  label="Data do diagnóstico"
                  text={data.dataDiagnosticoELA}
                />
                <Item
                  label="Classificação King's College"
                  text={data.classificacaoKingsCollege}
                />
                <Item
                  label="Escala funcional ALSFRS-R"
                  text={data.escalaFuncional}
                />
                <Item
                  label="Velocidade de progressão"
                  text={data.velocidadeDeProgressao}
                />
                <Item label="Causa" text={data.causaELA} />
                <Item label="Local de início" text={data.localDeInicio} />
                <Item label="Fenótipo de início" text={data.fenotipoDeInicio} />
              </Stack>
              <Item label="Observações" text={data.observacaoELA} />
            </Stack>
          )}
          {data.diagnosticoEhELA === "Não" && (
            <Stack>
              <Stack className="template-grid column-4">
                <Item
                  label="O diagnóstico é ELA?"
                  text={data.diagnosticoEhELA}
                />
                <Item
                  label="Sugestão de diagnóstico"
                  text={data.sugestaoDiagnostico}
                />
              </Stack>
              <Item label="Observações" text={data.observacaoELA} />
            </Stack>
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
